import { Button, LogoMark, Skeleton, errorMessage } from "@ml/ui";
import { RefreshCw } from "lucide-react";

/** Whole-screen splash while we find out who you are. */
export function FullPageLoader() {
  return (
    <div className="gfp-splash" role="status" aria-live="polite">
      <LogoMark size={56} title="" className="gfp-splash__mark" />
      <span className="gfp-splash__string" aria-hidden="true" />
      <span className="gf-sr-only">Loading Magically Linked</span>
    </div>
  );
}

export function FullPageError({ error, onRetry }: { error: unknown; onRetry: () => void }) {
  return (
    <div className="gfp-splash">
      <LogoMark size={48} title="" />
      <h1 className="gfp-splash__title">We can't reach Magically Linked right now.</h1>
      <p className="gfp-splash__text">{errorMessage(error, "Something went wrong loading your account.")}</p>
      <Button variant="secondary" icon={<RefreshCw size={16} />} onClick={onRetry}>
        Try again
      </Button>
    </div>
  );
}

/** Placeholder layout while a page's first query loads. */
export function PageSkeleton() {
  return (
    <div className="gfp-page-skeleton" aria-busy="true" aria-label="Loading">
      <Skeleton height={34} width={280} />
      <Skeleton height={14} width={420} />
      <div className="gfp-page-skeleton__grid">
        <Skeleton height={120} radius={10} />
        <Skeleton height={120} radius={10} />
        <Skeleton height={120} radius={10} />
      </div>
      <Skeleton height={260} radius={10} />
    </div>
  );
}
